<script setup lang="ts">
  import { watch } from 'vue';
  import { IconRadio } from '@/shared/ui';
  import { useDocumentRevision } from '../model/revision/useDocumentRevision';

  const props = defineProps<{
    modelValue: string;
    hasRevision: string;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void;
    (e: 'update:hasRevision', value: string): void;
  }>();

  const { hasRevision, externalRevision } = useDocumentRevision(props);

  function onExternalRevisionInput(event: Event) {
    const target = event.target as HTMLTextAreaElement;
    externalRevision.value = target.value;
  }

  watch(hasRevision, (newVal) => {
    emit('update:hasRevision', newVal);
    if (newVal === 'false') {
      externalRevision.value = '';
      emit('update:modelValue', '');
    }
  });

  watch(externalRevision, (newVal) => {
    emit('update:modelValue', newVal);
  });
</script>

<template>
  <div class="flex flex-col">
    <div class="flex flex-col gap-3 p-6">
      <label class="text-sm font-semibold text-gray-07">Possui revisão?</label>
      <div class="flex gap-6">
        <IconRadio
          v-model="hasRevision"
          value="true"
          label="Sim"
          name="hasRevision"
        />
        <IconRadio
          v-model="hasRevision"
          value="false"
          label="Não"
          name="hasRevision"
        />
      </div>
    </div>
    <div
      v-if="hasRevision === 'true'"
      class="flex flex-col gap-3 p-6"
    >
      <label class="text-sm font-semibold text-gray-07">Revisão Externa:</label>
      <textarea
        :value="externalRevision"
        rows="3"
        class="w-full p-3 border border-gray-02 rounded-md text-gray-07 resize-none focus:outline-none focus:border-gray-07"
        placeholder="Digite a revisão aqui"
        @input="onExternalRevisionInput"
      />
    </div>
  </div>
</template>
